import React, { useEffect, useState } from 'react';
import './AppGallery.css';
import { useLanguage } from '../context/LanguageContext';

// Import screenshot images
import img1 from '../assets/app-screenshots/1.jpeg';
import img2 from '../assets/app-screenshots/2.jpeg';
import img3 from '../assets/app-screenshots/3.jpeg';
import img4 from '../assets/app-screenshots/4.jpeg';
import img5 from '../assets/app-screenshots/5.jpeg';
import img6 from '../assets/app-screenshots/6.jpeg';
import img7 from '../assets/app-screenshots/7.jpeg';
import img8 from '../assets/app-screenshots/8.jpeg';

const galleryImages = [
  { id: 1, src: img1 },
  { id: 2, src: img2 },
  { id: 3, src: img3 },
  { id: 4, src: img4 },
  { id: 5, src: img5 },
  { id: 6, src: img6 },
  { id: 7, src: img7 },
  { id: 8, src: img8 }
];

const AppGallery = ({ onBackToHome }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
  };

  // Klavye ok tuşları ve ESC desteği
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;
      if (e.key === 'ArrowLeft') {
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
      } else if (e.key === 'ArrowRight') {
        setSelectedIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
      } else if (e.key === 'Escape') {
        setSelectedIndex(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex]);

  return (
    <div className="gallery-page-wrapper">
      <div className="container">
        {/* Navigation Bar */}
        <div className="page-nav-bar">
          <button className="back-btn" onClick={onBackToHome}>
            <i className="fa-solid fa-arrow-left"></i>
            <span>{t('gallery.backBtn')}</span>
          </button>
        </div>

        {/* Header */}
        <div className="section-header">
          <div className="section-badge">
            <i className="fa-solid fa-mobile-screen-button"></i>
            <span>{t('gallery.badge')}</span>
          </div>
          <h2 className="section-title">{t('gallery.title')}</h2>
          <p className="section-subtitle">
            {t('gallery.subtitle')}
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="app-gallery-grid">
          {galleryImages.map((item, index) => (
            <div
              key={item.id}
              className="gallery-card"
              onClick={() => setSelectedIndex(index)}
            >
              <div className="gallery-phone-frame">
                <div className="phone-screen-wrap">
                  <img
                    src={item.src}
                    alt={`SacredLifeX ${item.id}`}
                    className="gallery-img"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="gallery-hover-overlay">
                    <i className="fa-solid fa-magnifying-glass-plus"></i>
                    <span>{t('gallery.zoomHint')}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal Lightbox with Next & Prev */}
      {selectedIndex !== null && (
        <div className="gallery-modal" onClick={() => setSelectedIndex(null)}>
          <button className="modal-close" onClick={() => setSelectedIndex(null)} aria-label="Kapat">
            <i className="fa-solid fa-xmark"></i>
          </button>

          {/* Sol / Önceki Butonu */}
          <button className="modal-nav-btn prev-btn" onClick={handlePrev} aria-label="Önceki Görsel">
            <i className="fa-solid fa-chevron-left"></i>
          </button>

          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-phone-frame">
              <img
                src={galleryImages[selectedIndex].src}
                alt={`SacredLifeX Ekranı ${selectedIndex + 1}`}
                className="modal-img"
              />
            </div>
            <div className="modal-counter">
              <span>{selectedIndex + 1} / {galleryImages.length}</span>
            </div>
          </div>

          {/* Sağ / Sonraki Butonu */}
          <button className="modal-nav-btn next-btn" onClick={handleNext} aria-label="Sonraki Görsel">
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default AppGallery;
